import script from "./controller.vue?vue&type=script&lang=jsx"
export * from "./controller.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__